// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsOfUse_wrapper__I7N+I","container":"TermsOfUse_container__iQVx4","div":"TermsOfUse_div__-XBvY"};